import { InvitationLink } from "~/common/types/invitationLink";
import { api } from "./axios";

export const getInvitationLink = async (invitationCode: string) => {
  const { data } = await api.get<InvitationLink>(
    `/v1/patients/invitation-links/${invitationCode}`,
  );
  return data;
};
